import { NamingConfig } from '@shared/naming/naming-config';

export type MappingTemplate = {
  templateId: string;
  name: string;
  internalEventId: string;
  mapping: string;
  usageCount: number;
};

export const MappingTemplateNaming = NamingConfig<MappingTemplate>({
  key: 'MappingTemplate',
  modelName: { '=1': $localize`Template`, other: $localize`Templates` },
  fieldNames: {
    templateId: $localize`ID`,
    name: $localize`Name`,
    internalEventId: $localize`Internal Event`,
    mapping: $localize`Body`,
    usageCount: $localize`IntegrationCount`,
  },
});

